import { APIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

import { headers } from './constants';

import Identity from './identity';
import { getGoogleAuthInstance } from './initGoogleLogin';
import { isLegacyGoogleSetting } from './socialSignOnTypes';
export interface CheckSwgLoginResponse {
  identityExists: boolean;
}
/** @hidden */
export function isCheckSwgLoginResponse(object: any): object is CheckSwgLoginResponse {
  return (<CheckSwgLoginResponse>object).identityExists !== undefined;
}

/**
 * This method checks Arc Identity to see if Arc already has an identity for the Subscribe with Google user currently logged in on the browser.
 *
 * @param idToken idToken for the user from Google Auth2.
 */

export const checkSwgLogin = async (
  idToken?: string
): Promise<APIErrorResponse | CheckSwgLoginResponse | Error> => {
  let googleIdToken = idToken;
  if (!googleIdToken) {
    await getGoogleAuthInstance();
    if (isLegacyGoogleSetting(Identity._google)) {
      googleIdToken = Identity._google?.authInstance?.currentUser
        ?.get()
        ?.getAuthResponse()?.id_token;
    } else {
      // handle SIWG case
    }
  }

  if (!googleIdToken) {
    console.error(
      'No Google ID token found. Either the user is not logged in with Google, or the Google Auth2 SDK is incorrectly loaded.'
    );
    return { identityExists: false };
  }

  return fetch(`${Identity.apiOrigin}/identity/public/v1/swg/checkloginexists`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ token: googleIdToken })
  })
    .then(JSONResponseHandler)
    .then(response => {
      if (isCheckSwgLoginResponse(response)) {
        return response;
      } else {
        throw response;
      }
    });
};

export default checkSwgLogin;
